import React from "react";
import Textarea from "../../ui/textarea";
import {useFormState} from "../../hooks/useFormState";
import Button from "../../ui/button";
import classes from "../account/AssignModal.module.css";
import {useTranslation} from "react-i18next";
import {Competence} from "../../schema";
import Input from "../../ui/input";
import PhrasesEdit from "./PhrasesEdit";
import WithTooltip from "../../ui/tooltip";

type CompetenceInput = {
  name: string;
  description?: string;
  indicators: string[];
};

type contentProps = React.ComponentProps<"div"> & {
  competence?: Competence;
  initialName?: string;
  onSave?: (data: CompetenceInput) => void;
};

function CompetenceModalHeader() {
  const {t} = useTranslation();
  return <span>{t("components.CompetenceModal.title")}</span>;
}

function CompetenceModalContent({competence, initialName, onSave}: contentProps) {
  const {t} = useTranslation();

  const formState = useFormState<CompetenceInput>({
    initialValues: {
      name: initialName ?? competence?.name ?? "",
      description: (competence as any)?.description ?? "",
      indicators: (competence as any)?.indicators ?? [],
    },

    preventDefault: true,

    onSubmit: (data) => {
      onSave && onSave(data);
    },
  });

  const submitDisabled = !formState.values.name.trim();

  return (
    <form className={classes.root} method="post" onSubmit={formState.submitHandler}>
      <>
        <WithTooltip
          className={classes.help}
          as="span"
          helpText={t("components.CompetenceModal.nameHelpText")}
        >
          <p className={classes.helpText}>{t("components.CompetenceModal.nameLabel")}</p>
        </WithTooltip>
        <Input
          style={{marginBottom: "16px"}}
          required
          type="text"
          name="name"
          value={formState.values.name}
          onChange={formState.changeHandler}
          placeholder={t("components.CompetenceModal.namePlaceholder")}
        />


        <WithTooltip
          className={classes.help}
          as="span"
          helpText={t("components.CompetenceModal.descriptionHelpText")}
        >
          <p className={classes.helpText}>{t("components.CompetenceModal.descriptionLabel")}</p>
        </WithTooltip>
        <Textarea
            style={{marginBottom: "16px"}}
            name="description"
            value={formState.values.description ?? ""}
            rows={4}
            placeholder={t("components.CompetenceModal.descriptionPlaceholder")}
            onChange={formState.changeHandler}
          />


        <WithTooltip
          className={classes.help}
          as="span"
          helpText={t("components.CompetenceModal.indicatorsHelpText")}
        >
          <p className={classes.helpText}>{t("components.CompetenceModal.indicatorsLabel")}</p>
        </WithTooltip>
        <PhrasesEdit
          value={formState.values.indicators}
          onValueChange={(indicators) => {
            formState.setValues({indicators});
          }}
          textareaProps={{
            maxLength: 200,
            rows: 1,
            autoComplete: "off",
            placeholder: t("components.CompetenceModal.indicatorsPlaceholder"),
          }}
        />
        {formState.values.indicators.length === 0 && (
          <p className={classes.warning}>
            {t("components.CompetenceResultsModal.noIndicatorsWarning")}
          </p>
        )}
      </>

      <div className={classes.bottom}>
        <Button type="submit" color={submitDisabled ? "secondary" : "success"} disabled={submitDisabled}>
          {t("common.save")}
        </Button>
      </div>
    </form>
  );
}

const CompetenceModal = {
  Header: CompetenceModalHeader,
  Content: CompetenceModalContent,
};

export default CompetenceModal;

